import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetPostPreviewActionType {
  Reset = 'post/resetPostPreview',
}

export type TResetPostPreview = ITypedReduxAction<EResetPostPreviewActionType.Reset>;
